import { baseApiV2 } from '@verantos-dev/app-state-base';
import { getCohortsPath } from '@verantos-dev/core-constants';
import { CohortTranslation, SelectStatementType } from '@verantos-dev/types-cohorts';
import { ObjectResponse } from '@verantos-dev/types-common';

export const cohortsTranslationApiSlice = baseApiV2.enhanceEndpoints({}).injectEndpoints({
  endpoints: (builder) => ({
    generateSQLTranslation: builder.mutation<
      ObjectResponse<CohortTranslation>,
      {
        projectId: string;
        cohortId: string;
        cohortDsl: string;
        selectStmtType: SelectStatementType;
      }
    >({
      query: ({ cohortDsl, cohortId, projectId, selectStmtType }) => ({
        url: `${getCohortsPath(projectId)}/${cohortId}/translate`,
        method: 'POST',
        body: { cohortDsl, selectStmtType },
      }),
    }),
  }),
});

export const { useGenerateSQLTranslationMutation } = cohortsTranslationApiSlice;
